
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { SoundEffectPackAPI } from "@/common/api/userManage/soundEffectPack";
import { CommonApi } from "@/common/api/common";
import { getCommonList,shareConfirmOptions } from '@/common/config';
import {DeepLoop} from '@/common/deepLoop/deepLoop';
import { Howl } from 'howler';

export const pageApiList = getPageAPIs(SoundEffectPackAPI);


@Component({
  filters: {

  }
})
export default class DeviceList extends Vue {
  private utilInstance: any;
  private soundEffectPackAPI: any;

  private commonApi: any;

  private deepLoopUtil: any = {};


  private packForms:any = {
    voice_sound_pack_id:'',
    voice_sound_id:''
  }

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.soundEffectPackAPI = new SoundEffectPackAPI();

    this.commonApi = new CommonApi();

    this.utilInstance = new Util();

  }

  private get voice_id() {
    const route = this.$route 

    const {
      query = {}
    } = route || {}

    const {
      roleVoiceId = ''
    } = query
    return roleVoiceId
  }

  private firstLoading: boolean = true;

  private form: any = {

  };

  private currentRow:any = {}

  private dialogVisible:boolean  = false

  private voicePackVisible:boolean = false

  private uploadVisible = false

  private openType:number = 1 // 1增加 2编辑
  private addForm:any = {
    name:'',
  }

  private activated(): void {
    this.getTable();
  }
  private destroyed() {
    this.stopAndClearAuidoPlayer()
  }
  private deactivated() {
    this.stopAndClearAuidoPlayer()
  }
  private getTable(): void {
    this.soundEffectPackAPI.getList(
      this.getTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getPackTable(): void {
    const {pageNo,pageSize} = this.packTablePage
    const {voice_sound_id} = this.packForms
    if(!voice_sound_id){
      return
    }
    const params ={
      page : pageNo,
      limit : pageSize,
      voice_sound_id:voice_sound_id
    }
    this.soundEffectPackAPI.getInfoList(params,
        (res: any) => {
          console.log(res, "res");
          const { data } = res;

          const { list, count, page, prepage } = data || {};

          const newTableList = Array.isArray(list)
              ? list.map(this.handleTableData)
              : [];

          this.$set(this.packTablePage, "totalCount", count);
          this.$set(this.packTablePage, "pageNo", page);
          this.$set(this.packTablePage, "pageSize", prepage);

          this.packTableData = newTableList;

          this.firstLoading = false;
        },
        () => {
          this.firstLoading = false;
        }
    );
  }
  private getTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      name
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};



    const outerParams: any = {
      voice_id: this.voice_id
    };

    if(name){
      outerParams.name=name
    }


    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;
      outerParams.__isUnique = !firstLoading;
    }


    return outerParams;
  }


  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }


  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getTable();
  }

  private tableData: any[] = [];
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }


  private packTableData: any[] = [];
  private packTablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChangePack(val: any) {
    this.packTablePage.pageNo = val.currentPage;
    this.packTablePage.pageSize = val.pageSize;

    this.getPackTable();
  }

  private addEditForm(type:number=1,row:any={}){
    this.addForm = new Util().clearObject(this.addForm);
    this.openType = type
    if(this.openType===2){
      const { name,id} = row
      this.addForm.name = name
      this.packForms.voice_sound_id = id
    }
    this.dialogVisible = true
  }

  private handlePublish(id: string): void {
    this.$confirm("确认发布该音效吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.soundEffectPackAPI.publish(
          {
            voice_sound_id: id,
          },
          () => {
            this.$message.success("发布成功");
            this.getTable();
          }
      );
    });
  }


  private handleDelete(id: string): void {
    this.$confirm("确认删除该音效吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.soundEffectPackAPI.delete(
          {
            voice_sound_id: id,
          },
          () => {
            this.$message.success("删除成功");
            this.getTable();
          }
      );
    });
  }

  private handleConfirm() {
    this.addForm['voice_id'] = this.voice_id
    this.soundEffectPackAPI.add(this.addForm,
        () => {
          this.$message.success('新增成功');
          this.dialogVisible = false;
          this.getTable();
        },
        () => {
        }
    );
  }
  private handleConfirmPack() {

    const { name }= this.addForm
    const {voice_sound_pack_id,voice_sound_id} = this.packForms
    console.log('2222', this.packForms)
    const params = {
      name,
      voice_sound_pack_id:voice_sound_pack_id,
      voice_sound_id:voice_sound_id
    }
    this.soundEffectPackAPI.edit(params,
        () => {
          this.$message.success('编辑成功');
          if(this.dialogVisible){
            this.dialogVisible = false;
            this.getTable()
          }
          if(this.uploadVisible){
            this.uploadVisible = false;
            this.getPackTable();
          }

        },
        () => {
        }
    );

  }
  private handleEditPack(row:any){
    this.currentRow = row
    this.packForms.voice_sound_id = row.id
    this.voicePackVisible = true
    this.getPackTable()
  }
  private uploadVoicePack(){
    this.upfileList = []
    this.uploadVisible = true
  }

  private upfileList: any[] = []

  private upFileloading: boolean = false

  private handleCustomFileUploadFile(file: any) {
    this.upFileloading = true;
    this.commonApi.getOssLimitIntNameFile(
        file instanceof File ? file : file.raw,
        (res: any) => {
          console.log(res, "res 文件上传成功");

          const { data } = res;

          const { data: uploadFileObj } = data || {};

          const { item: uploadFile } = uploadFileObj || {};

          const { id, url,file_name } = uploadFile || {};

          this.$set(this.packForms, 'voice_sound_pack_id', id)
          this.$set(this.packForms, 'voice_sound_pack_url', url)

          this.upfileList.push({
            id,
            url,
            name: file_name
          })

          console.log(this.packForms, 'packForms')

          this.upFileloading = false;
        },
        (err: any) => {
          const {
            errMsg = ''
          } = err || {}

          this.$message.error(errMsg || "文件上传失败");

          this.upFileloading = false;
        },
    );
  }

  private onFileRemove(file: any) {
    const upfileList = this.upfileList

    const existFileIndex = upfileList.findIndex((eachFile) => eachFile.id == file.id)

    if (existFileIndex > -1) {
      this.upfileList.splice(existFileIndex, 1)

      this.$set(this.packForms, 'voice_sound_pack_id', '')
      this.$set(this.packForms, 'voice_sound_pack_url', '')
    }
  }

  private audioPlayer: any
  private onPlayAudioPack(item: any) {
    const {
      sound_file_url
    } = item || {}

    if (!sound_file_url) {
      this.$message.error('缺失音效链接')
      return
    }

    if (this.audioPlayer) {
      this.stopAndClearAuidoPlayer()
    }

    const sound = this.audioPlayer = new Howl({
      src: [sound_file_url]
    });

    sound.once('load', function(){
      sound.play();
    });
  }
  private stopAndClearAuidoPlayer() {
    this.audioPlayer.stop()

    this.audioPlayer = null
  }
}
